<template lang="pug">
  v-select(
    dense
    outlined
    hide-details
    :value='value'
    :items='itemsTrans'
    item-text='name'
    item-value='value'
    :label="$t('label.select-voucher-type')"
    @input="$emit('input',$event)"
    @click="$emit('click')"
  )

</template>
<script>
export default {
  props:{
    value:{
      type:String,
      default:null
    }
  },
  data: () => ({
    items:[
      {
        name:"all",
        value:null,
      },
      {
        name:"AVAILABLE",
        value:"AVAILABLE",
      },
      {
        name:"EXPIRED",
        value:"EXPIRED",
      },
      {
        name:"ACTIVATED",
        value:"ACTIVATED",
      },
    ] 
  }),
  computed: {
    itemsTrans () {
      return this.items.map(x=>{ 
        x.name = this.$t(x.name) 
        return x
      })
    }
  }
}
</script>